module.exports = __webpack_public_path__ + "img/bg-footer-home.56b7d8b3.jpg";